import type { FunctionComponent } from 'react';

/**
 * ListRowTitle is the "title" or primary piece of text
 * in a given list row.
 */
const ListRowTitle: FunctionComponent = ({ children }) => (
  <div className="fossa-list__row__title">
    {children}
  </div>
);

export default ListRowTitle;
